export const AVATAR_IMAGE_TEST_ID: string = "sidebar-avatar-image";
export const AVATAR_FALLBACK_TEST_ID: string = "sidebar-avatar-fallback";
